class LqdProgressbarHandler extends elementorModules.frontend.handlers.Base {

  onInit(...args) {

    super.onInit(...args);

    this.initProgressbar();

  }

  getDefaultSettings() {
    return {
      selectors: {
        progressbarElement: '[data-progressbar]',
      }
    }
  }

  getDefaultElements() {
    const selectors = this.getSettings('selectors');
    return {
      $progressbarElement: this.$element.find(selectors.progressbarElement),
    }
  }

  initProgressbar() {

    this.elements.$progressbarElement.liquidProgressbar();

  }
  
}

export default ($element) => {
  elementorFrontend.elementsHandler.addHandler( LqdProgressbarHandler, { $element } );
};